// @flow
import { values } from "ramda"
import { breakpoints } from "common/mediaQuery"

export function lighten(hex: string, alpha: number) {
  return `rgba(${parseInt(hex.substring(1, 3), 16)},${parseInt(
    hex.substring(3, 5),
    16,
  )},${parseInt(hex.substring(5, 7), 16)},${alpha})`
}

export type Theme = {|
  borderRadiuses: {|
    button: string,
    filterButton: string,
    input: string
  |},
  breakpoints: Array<number>,
  color: {|
    background: string,
    green: string,
    light: string,
    lightGray: string,
    primaryAccent: string,
    primaryAccentDark: string,
    primaryText: string,
    red: string,
    secondaryText: string,
    shadow: string,
    white: string,
    yellow: string
  |},
  fontWeights: {|
    bold: number,
    book: number,
    medium: number,
    normal: number,
    ultra: number
  |},
  zIndices: {|
    contextMenu: number,
    header: number,
    minimal: number,
    modal: number,
    notification: number,
    overlay: number,
    overlayContent: number,
    overlayOverlay: number
  |}
|}

export const defaultTheme: Theme = {
  color: {
    // Theme colors
    primaryAccent: "#00bed0",
    primaryAccentDark: "#009daf",
    primaryText: "#000f32",
    secondaryText: "#7f899e",
    background: "#ffffff",

    // Static colors - not intended to be overridden
    light: "#f5f5f7",
    shadow: "#f1f1f7",
    lightGray: "#d9dee6",
    white: "#ffffff",
    red: "#ec4833",
    green: "#0acd8e",
    yellow: "#ffa900",
  },
  zIndices: {
    minimal: 1,
    overlayOverlay: 98,
    overlayContent: 99,
    overlay: 100,
    header: 100,
    contextMenu: 500,
    modal: 1000,
    notification: 10000,
  },
  breakpoints: values(breakpoints),
  fontWeights: { normal: 400, book: 500, medium: 600, bold: 700, ultra: 900 },
  borderRadiuses: { button: "0.5rem", filterButton: "0.2rem", input: "0.5rem" },
}



// WEBPACK FOOTER //
// ./src/global/theme.js